import { ActionTree, ActionContext } from 'vuex'

import { State } from './state'
import { Mutations } from './mutation'
import { ActionTypes, MutationTypes } from './type'
import service from '@/groupBuy/services'

import {
  RequestListResponse,
  RequestItemModel
} from '@/groupBuy/types'

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1]
  ): ReturnType<Mutations[K]>
} & Omit<ActionContext<State, State>, 'commit'>

export interface Actions {
  [ActionTypes.INIT_DATA](
    { commit }: AugmentedActionContext,
  ): void
}

export const actions: ActionTree<State, State> & Actions = {
  [ActionTypes.INIT_DATA]: async ({ commit }) => {
    const data: RequestListResponse = await service.getRequestList()
    if (data) {
      commit(MutationTypes.SET_REQUEST_LIST, data.groupBuyItems as RequestItemModel[])
    }
  },
  [ActionTypes.REMOVE_REQUEST]: ({ commit }, uuid: string) => {
    commit(MutationTypes.REMOVE_REQUEST, uuid)
  }
}
